<template>
  <div>
    <van-nav-bar
        title="报名人员列表"
        left-text="返回"
        right-text="导出Excel"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
    />
    <van-cell title="选择查询的日期范围"
              :value="selectDate[0].toLocaleDateString() +'至'+ selectDate[1].toLocaleDateString()"
              @click="selectDateShow = true"/>
    <van-calendar v-model:show="selectDateShow" type="range" @confirm="onConfirmSelectDate"
                  :min-date="new Date(2021, 0, 1)" :max-date="new Date()"/>

    <van-list v-model:loading="loading" :finished="finished">
      <van-cell
          is-link
          clickable
          v-for="item in list"
          :key="item.id"
          :title="item.name"
          value="详情"
          center
          :label="handleData(item)"
          @click="openMinute(item)"
      />
    </van-list>
  </div>
</template>

<script>
import {useRouter} from "vue-router";
import {onMounted, reactive, ref, toRefs} from "vue";
import axios from "../../api/http";

export default {
  setup() {
    const router = useRouter();

    function onClickLeft() {
      router.back();
    }

    function onClickRight() {
      if (listDemo.list.length > 0) {
        require.ensure([], () => {
          const {export_json_to_excel} = require("@/vendor/Export2Excel");
          const tHeader = ["姓名", "性别", "手机号", "证件种类", "作业类别", "准操项目", "课训种类", "是否缴费", "缴费金额", "报名时间", "单位", "学历", "原证件编号"];
          const filterVal = ["name", "sex", "phone", "speciesName", "projectName", "courseName", "ltchoose", "isPay", "money", "time", "dept", "education", "cardNumber"];
          const data = formatJson(filterVal, listDemo.list);
          export_json_to_excel(tHeader, data, "淮海安全培训考生报名情况表");
        });
      }
    }

    /**
     * 对导出数据格式处理
     */
    function formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'isPay') {
          if (v[j]) {
            return '已缴费'
          } else {
            return '未缴费'
          }
        } else if (j === 'time') {
          return v[j].substring(0, 10)
        } else {
          return v[j]
        }
      }));
    }

    const listDemo = reactive({
      list: [],
      loading: false,
      finished: false
    });

    const selectDateShow = ref(false)

    const now = new Date(); //当前日期
    const nowMonth = now.getMonth(); //当前月
    const nowYear = now.getFullYear(); //当前年
    //本月的开始时间
    const monthStartDate = new Date(nowYear, nowMonth, 1);
    //本月的结束时间
    const monthEndDate = new Date(nowYear, nowMonth + 1, 0);
    const selectDate = ref([monthStartDate, monthEndDate])

    function onConfirmSelectDate(values) {
      console.log(values)
      selectDate.value = values
      selectDateShow.value = false
      getAllRegisterPerson();
    }

    const sumMonth = (month) => {
      const mt = month + 1
      if (mt < 10) {
        return '0' + mt
      } else {
        return mt
      }
    }

    const sumDay = (month) => {
      const mt = month
      if (mt < 10) {
        return '0' + mt
      } else {
        return mt
      }
    }

    const getAllRegisterPerson = () => {
      const start = selectDate.value[0].getFullYear() + '-' + sumMonth(selectDate.value[0].getMonth()) + '-' + sumDay(selectDate.value[0].getDate()) + ' 00:00:00'
      const end = selectDate.value[1].getFullYear() + '-' + sumMonth(selectDate.value[1].getMonth()) + '-' + sumDay(selectDate.value[1].getDate()) + ' 23:59:59'
      axios.get("/api/RegisterInfo/GetAllRegister/" + start + "/" + end).then(res => {
        listDemo.finished = true;
        listDemo.list = res.data.filter(p => p.isPay)
      });
    };

    function handleData(item) {
      return item.phone + '  [已缴费：' + item.money + '元]'
    }

    onMounted(() => {
      getAllRegisterPerson();
    });


    function openMinute(item) {
      console.log(item);
      router.push({
        name: "registerMinute",
        params: {
          cardNegative: item.cardNegative,
          cardNumber: item.cardNumber,
          cardPositive: item.cardPositive,
          courseID: item.courseID,
          courseName: item.courseName,
          dept: item.dept,
          education: item.education,
          healthBook: item.healthBook,
          id: item.id,
          isPay: item.isPay,
          ltchoose: item.lTChoose,
          money: item.money,
          name: item.name,
          phone: item.phone,
          poq: item.poq,
          projectID: item.projectID,
          projectName: item.projectName,
          sex: item.sex,
          speciesID: item.speciesID,
          speciesName: item.speciesName,
          time: item.time,
          retrainNegative: item.retrainNegative,
          retrainPositive: item.retrainPositive
        }
      });
    }

    return {
      onClickLeft,
      onClickRight, ...toRefs(listDemo),
      openMinute,
      selectDateShow,
      selectDate,
      onConfirmSelectDate,
      handleData
    };
  }
};
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.block {
  width: 90%;
  height: 90%;
  background-color: #fff;
  overflow-y: auto;
}

.image-title {
  margin-bottom: 20px;
}

.image {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}
</style>
